/* unplugin-vue-components disabled */import { render } from "./signal-about.vue?vue&type=template&id=30498336&scoped=true"
import script from "./signal-about.vue?vue&type=script&lang=js"
export * from "./signal-about.vue?vue&type=script&lang=js"

import "./signal-about.vue?vue&type=style&index=0&id=30498336&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30498336"],['__file',"src/pages/pulse/signal/signal-about.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30498336"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30498336', __exports__)) {
    api.reload('30498336', __exports__)
  }
  
  module.hot.accept("./signal-about.vue?vue&type=template&id=30498336&scoped=true", () => {
    api.rerender('30498336', render)
  })

}


export default __exports__